<template>
  <div class="wrapper">
    <!-- <Loader /> -->
    <Sidebar />
    <Header />
    <div
      id="content-page"
      class="content-page background-inside"
    >
      <transition
        name="router-anim"
        mode="out-in"
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOut"
      >
        <router-view />
      </transition>
    </div>
    <Footer />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { core } from '@/config/pluginInit'

import Header from '@/components/core/header/Header.vue'
import Sidebar from '@/components/core/sidebar/Sidebar.vue'
import Footer from '@/components/core/footer/Footer.vue'

// import Loader from '@/components/core/loader/Loader'

export default {
  name: 'MainLayout',
  components: {
    // Loader,
    Header,
    Sidebar,
    Footer
  },
  computed: {
    ...mapGetters({
      darkMode: 'settings/darkModeState',
      user: 'auth/user'
    })
  },
  mounted () {
    core.index()
    core.mainIndex()
    this.modeChange({ rtl: false, dark: this.darkMode })
  },
  destroyed () {
    document.body.classList = ''
  },
  methods: {
    ...mapActions({
      modeChange: 'settings/layoutModeAction'
    })
  }
}
</script>
